import json5 from 'json5';
import axios from 'axios';
import _ from 'lodash';
import dayjs from 'dayjs';
import url from 'url';
import queryString from 'query-string';

const TOKEN = 'eyJraWQiOiJpN1NKUndBYnJpcVZpdzdCMUk4MlwvSm1LeWdrSlBIbHV2d1wvOWFJQzg5NU09IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwZWFhMDJlNi00M2Y1LTRkY2EtYmE2Yy0zZWQ3MWQ1ODc1MDAiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmFwLW5vcnRoZWFzdC0xLmFtYXpvbmF3cy5jb21cL2FwLW5vcnRoZWFzdC0xX0JXb0RON1JYNSIsImNvZ25pdG86dXNlcm5hbWUiOiIwZWFhMDJlNi00M2Y1LTRkY2EtYmE2Yy0zZWQ3MWQ1ODc1MDAiLCJvcmlnaW5fanRpIjoiYTBkOGU0ZjEtNDM1MS00NTYxLThlOGEtN2I5ZjhmM2ExNGE3IiwiYXVkIjoiNWwxYWRpMTdiMXJwcG5ianJpYXR1ZjNwbzAiLCJldmVudF9pZCI6IjQ4NTNmNzE5LWEzYmUtNDQ2OC1hODI1LTI2ZGViMWZmOWQ0ZSIsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNzQzNDk0MzExLCJjdXN0b206c3ViIjoiMGVhYTAyZTYtNDNmNS00ZGNhLWJhNmMtM2VkNzFkNTg3NTAwIiwiZXhwIjoxNzQzNDk3OTExLCJpYXQiOjE3NDM0OTQzMTEsImp0aSI6IjY5MGY0ODgxLTU1MjItNDRlMy05MDJjLWJmNzc5NzEwZjBjMyIsImVtYWlsIjoidmp3X3Rlc3QxQHF1aWNrc2VuZC5jaCJ9.xYEXRFYUv3l_rhPgUah9SK5U13ltqTciJVqqV3s8b75WghxEquXNpHBFOs3GkF3KTtAhbUyLexqVcRNkjur__NO_W3JlC0y-jZTalaOTZbwaOcCubduUJNGYhC03-heN9IwWqvASzfRGdgFIpWk_bV92dr_C_dYo3_oGVHfu3NB7JJ_-IQeDru4AY4l4OY9neurOvhbW9n0e8kzvu08jl86uT3L7GNlxq_oKvkktajeAEZnHUheJ5ALKbS6IfE8l6EP0Ku6Db8Qps_mbPp2SNkk_RG9LLSZjHFgLX07iso-aD4XS234IRbwJIwDIzE3ykq_-LWM0tSRkZDu5YPje6A';
const apiJson5 = axios.create();
const api = axios.create();

/**
 * 
 */
apiJson5.interceptors.response.use(resp => {
    resp.data = _.isObject(resp.data) ? resp.data : json5.parse(resp.data);
    return resp;
});

/**
 * 
 * @param path 
 * @param params 
 * @returns 
 */
const getUrl = (path: string, params?: any) => {
    const reqData = dayjs().unix();
    const merged = _.merge({
        reqData: reqData
    }, params);
    return url.resolve(window.location.href, path) + '?' + queryString.stringify(merged);
}

/**
 * 
 * @param path 
 * @param params 
 * @returns 
 */
const getJson5 = (path: string, params?: any) => {
    const url = getUrl(path, params);
    return apiJson5.get(url);
}

/**
 * 
 * @param path 
 * @param params 
 * @returns 
 */
const get = (path: string, params?: any) => {
    const url = getUrl(path, params);
    return api.get(url);
}

/**
 * 
 * @param path 
 * @param params 
 * @returns 
 */
const getData = (path: string, params?: any) => {
    return api.get(path,{
        headers: {
            'x-api-key': TOKEN
        },
    });
}

/**
 * 
 * @param path 
 * @param params 
 * @returns 
 */
const post = (path: string, params: any) => {
    return api.post(path, params);
}

export default { getJson5, get, getData, post }